import { render, staticRenderFns } from "./delete-dialog.vue?vue&type=template&id=9d81662a&scoped=true&"
import script from "./delete-dialog.vue?vue&type=script&lang=js&"
export * from "./delete-dialog.vue?vue&type=script&lang=js&"
import style0 from "./delete-dialog.vue?vue&type=style&index=0&id=9d81662a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d81662a",
  null
  
)

export default component.exports